// Generated by scripts/generate-build-info.mjs. Do not edit, do not commit.
export const buildInfo = {
  version: "0.9.1",
  buildVersion: "2026-11-02-374178392-a5e9281-dev",
  commit: "a5e9281487d028ad36cdf89e40b9f2f2fec21538",
  commitShort: "a5e9281",
  branch: "dev",
  buildTime: "2026-11-02T15:34:47.213Z",
} as const;
